module.exports = "<div *ngIf=\"!valid\">\n  <p class=\"form-control-feedback\" [ngClass]=\"{'take-space': takeSpace}\">{{getValidationMessage(error)}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/validation-message/validation-message.component.html
// module id = wvGA
// module chunks = 0